<template>
  <div class="page">
    <div class="container">
      <div class="header">
        <el-image :src="require('@/assets/LOGO.svg')" @click="toHome" style="cursor: pointer;width: 155px; height: 21px;"></el-image>
        <div class="header__content">
          <a href="mailto:exam@holowits.com" class="contact">Contact Us</a>
        </div>
      </div>
      <div class="container__body">
        <h1 class="login_title">Change Password</h1>
        <el-form :model="loginForm" class="login_form" :rules="rules" ref="loginForm">
          <el-form-item prop="account">
            <el-input placeholder="Email" v-model="loginForm.account"/>
          </el-form-item>
          <el-form-item prop="oldPassword">
            <el-input class="password-input" placeholder="Old Password" v-model="loginForm.oldPassword" show-password/>
          </el-form-item>
          <el-form-item prop="password" class="has-tips-form-item">
            <div class="flex-content">
              <el-input class="password-input" placeholder="New Password" v-model="loginForm.password" show-password/>
              <div>
                <el-popover placement="bottom-start" width="236" popper-class="cus-popper" :offset="-10">
                  <div class="tips-content">
                    <p>For your account security your new password must:</p>
                    <ul>
                      <li>Contain at least 8 characters.</li>
                      <li>Contain any combination of letters, digits, and special characters.</li>
                    </ul>
                  </div>
                  <div class="tips-btn" slot="reference"></div>
                </el-popover>
              </div>
            </div>
          </el-form-item>
          <el-form-item prop="confirmPassword">
            <el-input class="password-input" placeholder="Confirm Password" v-model="loginForm.confirmPassword" show-password/>
          </el-form-item>
          <el-form-item prop="code">
            <div class="flex-content">
              <el-input placeholder="Verification Code" v-model="loginForm.code"/>
              <div class="verification-code-image" @click="getCodeImage">
                <img :src="imageCode" alt="">
              </div>
            </div>
          </el-form-item>
        </el-form>
        <div class="flex-btn-group">
          <el-button type="primary" class="submit_btn" plain @click="cancelSubmit">Cancel</el-button>
          <el-button type="primary" class="submit_btn" @click="submitUpdate">Submit</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {updatePassword, getCaptcha} from '@/api/login';
  import {randomNum} from '@/utils/commons';

  export default {
    name: 'index',
    data() {
      return {
        loading: false,
        loginForm: {
          account: '',
          oldPassword:'',
          password: '',
          confirmPassword:'',
          code:'',
          tenant: 'cGFydG5lcg==',
          key: randomNum(24, 16),
        },
        imageCode: '',
        rules: {
          account: [{required: true, message: 'Email cannot be empty.', trigger: 'blur'}],
          password: [{required: true, message: 'Password cannot be empty.', trigger: 'blur'}],
        },
      };
    },
    mounted() {
      this.getCodeImage();
    },
    methods: {
      toHome() {
        this.$router.replace({name: 'home'});
      },

      getCodeImage() {
        getCaptcha(this.loginForm.key).then(response => {
          const res = response.data;
          return ('data:image/png;base64,' + btoa(new Uint8Array(res).reduce((data, byte) => data + String.fromCharCode(byte),'',),)
          );
        }).then(res => {
          this.imageCode = res;
        }).catch(e => {
          if (e.toString().indexOf('429') !== -1) {
            this.$message({
              message: this.$t('tipInfo.tooManyRequest'),
              type: 'error',
            });
          } else {
            this.$message({
              message: this.$t('tipInfo.getCodeImageFailed'),
              type: 'error',
            });
          }
        });
      },

      submitUpdate() {
        this.$refs.loginForm.validate(valid => {
          if (valid) {
            //两次密码不一样
            if(this.loginForm.password != this.loginForm.confirmPassword){
              this.$message({
                message: this.$t('tipInfo.errorPwd'),
                type: 'error',
              });
              return
            }
            this.loading = true;
            const meta = {
              tenant: this.loginForm.tenant,
              'X-isTenant': false,
              'X-isToken': false,
            };
            updatePassword(this.loginForm, meta).then(res => {
              const response = res.data;
              if (response.isSuccess) {
                this.updateSuccess()
              }
            });
          } else {
            return false;
          }
        });
      },
      cancelSubmit(){
        this.$refs.loginForm.clearValidate()
        this.$refs.loginForm.resetFields()
        this.$router.push('/login');
      },
      updateSuccess() {
        this.$message({
          message: this.$t('tipInfo.loginSuccess'),
          type: 'success',
        });
        this.$router.push('/login');
      },
    },
  };
</script>

<style scoped lang="less">
  @import "login";
</style>
<style scoped lang="scss">
  .cus-popper {
    transform: translateY(-8px);
  }
</style>
